import { BusRouteDataMap } from '../mock-map/constant/route-types';
import { Stop, Trip } from '../types/mock-timetable-type';

export function extractBusArrMap(
  routeMap: BusRouteDataMap
): Record<string, string[]> {
  return Object.fromEntries(
    Object.entries(routeMap).map(([routeId, routeData]) => [
      routeId,
      routeData.busArr,
    ])
  );
}

type PrevNextStop = {
  previousStop?: Stop;
  nextStop?: Stop;
};
